import { Application } from "@hotwired/stimulus";
import controllers from "./controllers-index.js";

const application = Application.start();
application.debug = false;

function toIdentifier(segment) {
  return segment
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
    .replace(/_/g, "-")
    .toLowerCase();
}

for (const { name, controller } of controllers) {
  const cleanName = name.replace("Controller", "").replace(/_/g, "-");
  const identifier = toIdentifier(cleanName);
  application.register(identifier, controller);
}
